import React from 'react';
import { crossSVG, editSVG } from '../../lib/allCustomSVGs';
import CustomSVGs from '../../ui/customSVGs/CustomSVGs';

interface Shop {
  id: string | number;
  slug: string;
  name: string;
  webshop_url: string;
}

interface ClientCardProps {
  shop: Shop;
  isActive: boolean;
  isSwitching: boolean;
  isSwitchingTarget: boolean;
  canManage?: boolean;
  canDelete?: boolean;
  onClick: () => void;
  onRename?: () => void;
  onDelete?: () => void;
}

const ClientCard: React.FC<ClientCardProps> = ({
  shop,
  isActive,
  isSwitching,
  isSwitchingTarget,
  canManage = false,
  canDelete = false,
  onClick,
  onRename,
  onDelete,
}) => {
  const initial = shop.name?.charAt(0)?.toUpperCase() || 'C';

  return (
    <div
      className={`clientCard ${
        isActive && !isSwitching ? 'clientCard--active' : ''
      } ${isSwitchingTarget ? 'clientCard--switching' : ''} ${
        isSwitching ? 'clientCard--disabled' : ''
      }`}
      onClick={onClick}
      role='button'
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div className='clientCard__avatar'>{initial}</div>
      <div className='clientCard__info'>
        <span className='clientCard__name'>{shop.name}</span>
        <span className='clientCard__url'>{shop.webshop_url || ''}</span>
      </div>
      {canManage && onRename && (
        <button
          type='button'
          className='clientCard__edit'
          title='Rename brand'
          aria-label='Rename brand'
          disabled={isSwitching}
          onClick={(e) => {
            e.stopPropagation();
            onRename();
          }}
        >
          <CustomSVGs svg={editSVG} />
        </button>
      )}
      {canDelete && onDelete && (
        <button
          type='button'
          className='clientCard__delete'
          title='Delete brand'
          aria-label={`Delete ${shop.name}`}
          disabled={isSwitching}
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
        >
          <CustomSVGs svg={crossSVG} />
        </button>
      )}
      {isActive && <div className='clientCard__badge'>Active</div>}
      {isSwitchingTarget && (
        <div className='clientCard__loading'>
          <div className='clientCard__spinner' />
        </div>
      )}
    </div>
  );
};

export default ClientCard;
